import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
	MatLegacyAutocomplete as MatAutocomplete,
	MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent,
} from '@angular/material/legacy-autocomplete';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import {
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	RestService,
} from 'cargo-chief-commons';
import { of } from 'rxjs';

@Component({
	selector: 'app-contact-autocomplete',
	templateUrl: './contact-autocomplete.component.html',
	styleUrls: ['./contact-autocomplete.component.scss'],
})
export class ContactAutocompleteComponent implements OnInit {
	isLoading = false;
	contactCtrl = new UntypedFormControl();
	listOfContacts: any[];
	selectedContact: any;

	@ViewChild('contactInput') contactInput: ElementRef;
	@ViewChild('auto') matAutocomplete: MatAutocomplete;
	@Input() carrierId: string;
	@Input() skipPrimaryContact: boolean;
	@Input() contactList: any[];
	@Output() contactSelected: EventEmitter<any> = new EventEmitter();

	constructor(
		private urlService: UrlService,
		public utilService: UtilService,
		private restService: RestService
	) {}

	ngOnInit() {
		this.contactCtrl.valueChanges
			.pipe(
				debounceTime(300),
				tap(() => {
					this.isLoading = true;
				}),
				switchMap((value) => {
					if (IS_NOT_EMPTY(value)) {
						if (IS_NULL_OR_UNDEFINED(this.contactList)) {
							const url = this.urlService.searchContacts(
								this.carrierId,
								value,
								this.skipPrimaryContact || null
							);
							return this.restService.GET(url);
						} else {
							const response = {
								data: {
									content: this.contactList.filter((contact) => {
										let isValid = true;
										if (this.skipPrimaryContact) {
											isValid = !contact.primaryContact;
										}
										return (
											contact.emailAddress.toLowerCase().includes(value.toLowerCase()) && isValid
										);
									}),
								},
							};
							return of(response);
						}
					} else if (
						IS_NOT_NULL_OR_UNDEFINED(this.contactInput.nativeElement.value) &&
						IS_NOT_EMPTY(this.contactInput.nativeElement.value)
					) {
						return;
					}
					this.contactSelected.emit(null);
					this.isLoading = false;
				})
			)
			.subscribe(
				(response: any) => {
					this.listOfContacts = response.data.content;
					this.isLoading = false;
				},
				(error) => {
					this.isLoading = false;
				}
			);
	}

	ngOnChanges() {
		if (IS_NULL_OR_UNDEFINED(this.selectedContact)) {
			this.contactCtrl.setValue('');
		} else {
			this.contactCtrl.setValue(this.selectedContact);
		}
	}

	selected(event: MatAutocompleteSelectedEvent): void {
		this.contactSelected.emit(event.option.value);
	}

	displayFn(contact: any) {
		return contact && contact.emailAddress ? `${contact.emailAddress} (${contact.fullName})` : '';
	}
}
